import React from 'react';
import { TranslationsFunc } from '../types';
import { useTranslations } from '../useTranslations';

type TranslationProps = { t: TranslationsFunc };

export function injectTranslations<T extends TranslationProps = TranslationProps>(
  WrappedComponent: React.ComponentType<T>
) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  function ComponentWithTranslation(props: Omit<T, keyof TranslationProps>) {
    const { t } = useTranslations();
    return <WrappedComponent {...(props as T)} t={t} />;
  }

  ComponentWithTranslation.displayName = `injectTranslations(${displayName})`;

  return ComponentWithTranslation;
}
